import api from './api';

export const getDatabaseData = async (params = {}) => {
  const response = await api.get('/exportimport/database', { params });
  // BO DEBUG
  // console.log('getDatabaseData Response data: ',response.data);
  // EO DEBUG
  return response.data;
};

export const exportXlsxTablesDatabase = 
  async (tables) => {
    const params = new URLSearchParams();
    tables.forEach(table => params.append('table', table));
    const response = await api.get('/exportimport/export-xlsx', {
      params,
      responseType: 'blob',
    });
    // Download file
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'export_tables.zip');
    document.body.appendChild(link);
    link.click();
    link.remove();
    return response.data;
  };

export const importXlsxTablesDatabase = async (tables, file) => {
  const formData = new FormData();
  tables.forEach(table => formData.append('table', table));
  formData.append('file', file);
  // for (let [key, value] of formData.entries()) {
  //   console.log(`formData ${key}:`, value);
  // }
  const response = await api.post('/exportimport/import-xlsx', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}
